import { cx } from "@emotion/css";
import { classCombinerFromPrefix } from "@/app/pages/upik/resources/RenderIdentifier";
import { TermsOfUseProps } from "@/app/pages/upik/resources/interfacesData";
import ContainerStyles from "@/app/pages/upik/styles/ContainerStyles.module.scss";
import React from "react";
import headerImage from "@/app/pages/upik/resources/upik-terms-of-use.jpg";
import {TermsOfUseContent} from "@/app/pages/upik/resources/content";

const styles = ContainerStyles;
const classCombiner = classCombinerFromPrefix("850cb40c5e9711c2");

export const TermsOfUse = (props: TermsOfUseProps): JSX.Element => {
    const germanTabClass = props.language === "de" ? "upikTermsofUseHeaderLinkActive" : "upikTermsofUseHeaderLink";
    const englishTabClass = props.language === "en" ? "upikTermsofUseHeaderLinkActive" : "upikTermsofUseHeaderLink";
    const htmlContent = props.language === "de" ? TermsOfUseContent.de : TermsOfUseContent.en;

    return (
        <div className={cx(classCombiner(styles, "upikTermsOfUseWrapper"))}>
            <div className="container mt-3">
                <div className="row">
                    <div className="col-md-12 px-4">
                        <div className={cx(
                            classCombiner(styles, "headerImage")
                        )} >
                            <img className={cx(classCombiner(styles, ""))} src={headerImage} alt="Header image" />
                        </div>
                        <div className={cx(classCombiner(styles, "termsOfUseHeaderText"))}>
                            <div
                                className={cx(classCombiner(styles, "upikHeaderSearchAndLinksWrapper"))}
                            >
                                <div className={cx(classCombiner(styles, "upikHeaderLinksWrapper"))}>
                                    <a
                                        className={cx(
                                            classCombiner(styles, germanTabClass)
                                        )}
                                        href="/de-de/upik/nutzungsbedingungen.html"
                                    >
                                        {props.language === "de" ? "DEUTSCH" : "GERMAN"}
                                    </a>

                                    {" "}

                                    {" "}

                                    |
                                    {" "}

                                    <a
                                        className={cx(
                                            classCombiner(styles, englishTabClass)
                                        )}
                                        href="/de-de/upik-en/terms-of-use.html"
                                    >
                                        ENGLISH
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 px-4">
                        <div dangerouslySetInnerHTML={{ __html: htmlContent }} ></div>
                    </div>
                </div>
            </div>
        </div>
    );
};
